import styled from "styled-components"

import { topBarSize, leftBarSize } from "../../../../Components/NavBar/styles";

export const Container = styled.div`  
    position: absolute;
    top: calc(${topBarSize});
    left: calc(${leftBarSize});

    width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
    height: calc(100% - calc(${topBarSize} + 2rem)) !important;

    padding-top: 1rem;
    padding-left: 1rem;


    z-index: 1;
`;

export const Title = styled.p`
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: rgba(55, 73, 87, 0.7);
    font-size: 2rem;

    z-index: 2;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
    
`;

export const DataGridButton = styled.button`
    margin-right: 1rem;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #0090C1;

    background: none;
    border: 2px solid #0090C1;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const Button = styled.button`
    position: absolute;
    right: 0%;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #2E933C;

    background: none;
    border: 2px solid #2E933C;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const UserDeleteOptions = styled.a`
    cursor: pointer;

    &:hover{
        opacity: 0.5;
    }
`;

export const UserDeleteOptionsRed = styled(UserDeleteOptions)`
    color: #DB3A34;
`;

export const UserDeleteOptionsGreen = styled(UserDeleteOptions)`
color: #2E933C;
`;